import React from "react";
import { CirclePicker } from "react-color";

function ColorPicker(props) {
  return (
    <div className="colorPickerCont">
      <CirclePicker
        onChangeComplete={props.handleChange}
        color={props.defaultColor}
        colors={props.colorArr}
      ></CirclePicker>
    </div>
  );
}

export default ColorPicker;
